export const getRequiredText = (text: string) => `${text} is required`
export const getValidText = (text: string) => `${text} must be valid`

const text = {
  PASSWORD_SUGGESTION: 'Use 8 or more characters with atleast one uppercase letter, numbers & symbols',
  PASSWORD_MATCH: 'Both password needs to be same',
}

export default text
